import type { ReactNode } from 'react'

import { Button, Flex, Heading, Paragraph, Popover } from '@buffer-mono/popcorn'

import styles from './LinkedInVerifiedSkills.module.css'

type RefreshChannelPopoverProps = {
  children: ReactNode
  isEnabled: boolean
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  onRefreshChannel: () => void
}

const RefreshChannelPopover = ({
  children,
  isEnabled,
  isOpen,
  onOpenChange,
  onRefreshChannel,
}: RefreshChannelPopoverProps): React.JSX.Element => {
  return (
    <Popover
      open={isEnabled && isOpen}
      onOpenChange={(nextIsOpen): void => {
        if (isEnabled) {
          onOpenChange(nextIsOpen)
        }
      }}
    >
      <Popover.Anchor>
        <span className={styles.refreshPopoverAnchor}>{children}</span>
      </Popover.Anchor>
      {isEnabled ? (
        <Popover.Content
          align="end"
          arrow={true}
          className={styles.refreshPopoverContent}
          side="top"
          size="medium"
        >
          <Flex direction="column" gap="md">
            <Flex direction="column" gap="xs">
              <Heading as="h4" size="sm">
                Let&apos;s setup LinkedIn Capabilities!
              </Heading>
              <Paragraph>
                To showcase your capabilities on LinkedIn, a quick channel
                refresh is needed.
              </Paragraph>
            </Flex>
            <Flex align="center" gap="sm" justify="end" fullWidth>
              <Button
                onClick={(): void => onOpenChange(false)}
                size="small"
                variant="tertiary"
              >
                Not Now
              </Button>
              <Button onClick={onRefreshChannel} size="small">
                Refresh Channel
              </Button>
            </Flex>
          </Flex>
        </Popover.Content>
      ) : null}
    </Popover>
  )
}

export { RefreshChannelPopover }
